import { Method as apiMethod } from 'axios'

export const reportEndpoints = {
  fetchReports: {
    method: 'get' as apiMethod,
    url: '/report/page'
  },
  getSubscriberReport: {
    method: 'get' as apiMethod,
    url: '/report/get_subscriber_report'
  },
  searchReports: {
    method: 'get' as apiMethod,
    url: '/report/search'
  }
}
